<template>
  <table class="ui striped basic table printable">
    <div v-show="loading" class="ui active inverted dimmer">
      <div class="ui text loader">Carregando...</div>
    </div>
    <thead>
      <tr>
        <th colspan="7" class="action-row">
          <div class="ui grid">
            <div class="row">
              <div class="four wide column">
                <router-link
                  class="new-record"
                  :to="`/contracts/${contract_id}/procedure_authorizations/new`"
                >
                  <i class="plus icon"></i>Nova autorização de procedimento
                </router-link>
              </div>
              <div class="right aligned twelve wide column">
                <div class="actions">
                  <a @click.prevent="refresh()">
                    <i class="refresh icon"></i>Atualizar
                  </a>
                </div>
              </div>
            </div>
          </div>
        </th>
      </tr>
      <tr>
        <th></th>
        <th>Data</th>
        <th>Procedimentos</th>
        <th>Valor</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(authorization, index) in authorizations" :key="index">
        <td>
          <router-link
            :to="`/contracts/${contract_id}/procedure_authorizations/${authorization.id}`"
          >
            <i class="edit icon"></i> Editar
          </router-link>
        </td>
        <td>{{ authorization.created_at | datetime }}</td>
        <td>{{ getProcedures(authorization.procedures) }}</td>
        <td>{{ authorization.value | money }}</td>
      </tr>
    </tbody>
  </table>
</template>
<script>
import exportCSV from '@/utils/exportCSV';
import printTable from '@/utils/printTable';

export default {
  data() {
    return {
      loading: false,
      authorizations: [],
      contract_id: null
    };
  },

  methods: {
    refresh() {
      this.$emit('refresh');
    },

    toggleLoading() {
      this.loading = !this.loading;
    },

    getProcedures(procedures) {
      return procedures.map(x => x.description).join(', ');
    },

    print() {
      const { headers, data } = this.getHeadersAndData();
      printTable(headers, data);
    },

    toCSV() {
      const { headers, data } = this.getHeadersAndData();
      exportCSV(headers, data, `${this.resource}`);
    },

    setData(authorizations, contract_id) {
      this.authorizations = _.clone(authorizations);
      this.contract_id = contract_id;
    }
  }
};
</script>
<style lang="css" scoped>
.actions a {
  padding: 0px 10px;
}
</style>
